import { render, staticRenderFns } from "./BackordersList.vue?vue&type=template&id=d7c87f68&"
import script from "./BackordersList.vue?vue&type=script&lang=js&"
export * from "./BackordersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports